/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class VerticalGroupingApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/verticalGroupingApply';
    }

    data({
        fullName,
        mobile,
        idCardNo,
        certCatId,
        certExamType,
        enterpriseName,
        enterpriseCooperationName,
        settlementRulesName,
        verticalGroupingName,
        verticalGroupingSn,
        examApplyTime,
        examTime,
        classExaminationType,
        verticalGroupingExamType,
        overallRatingResult,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let examApplyTimeBegin = null;
        let examApplyTimeEnd = null;
        if (examApplyTime != null && examApplyTime.length === 2) {
            [examApplyTimeBegin, examApplyTimeEnd] = examApplyTime;
        }
        let examTimeBegin = null;
        let examTimeEnd = null;
        if (examTime != null && examTime.length === 2) {
            [examTimeBegin, examTimeEnd] = examTime;
        }
        return super.get('/data', {
            fullName,
            mobile,
            idCardNo,
            certCatId,
            certExamType,
            enterpriseName,
            enterpriseCooperationName,
            settlementRulesName,
            verticalGroupingName,
            verticalGroupingSn,
            examApplyTimeBegin,
            examApplyTimeEnd,
            examTimeBegin,
            examTimeEnd,
            classExaminationType,
            verticalGroupingExamType,
            overallRatingResult,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new VerticalGroupingApply();
export { VerticalGroupingApply };
